import { Z as Xe, s as x, V as Pe, u as Vr, A as ae, k as Zr, K as se, x as Jr, p as en, Q as tn, D as rn, S as wt, i as Jt } from "./enums-a96ef472.mjs";
import { easeCubicInOut as nn, pointer as an, min as on, extent as sn, scaleLinear as un, scaleQuantize as ln } from "d3";
function Be(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
function ue(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, u = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[u] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[l];
  };
}
function le(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? fn(s, function(c) {
      return c.test(o);
    }) : cn(s, function(c) {
      return c.test(o);
    }), l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = r.valueCallback ? r.valueCallback(l) : l;
    var f = t.slice(o.length);
    return {
      value: l,
      rest: f
    };
  };
}
function cn(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function fn(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function dn(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
function Me(e) {
  "@babel/helpers - typeof";
  return Me = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Me(e);
}
function B(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function O(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function E(e) {
  O(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Me(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function hn(e, t) {
  O(2, arguments);
  var r = E(e).getTime(), n = B(t);
  return new Date(r + n);
}
var gn = {};
function Le() {
  return gn;
}
function mn(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function pn(e) {
  return O(1, arguments), e instanceof Date || Me(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function vn(e) {
  if (O(1, arguments), !pn(e) && typeof e != "number")
    return !1;
  var t = E(e);
  return !isNaN(Number(t));
}
function yn(e, t) {
  O(2, arguments);
  var r = B(t);
  return hn(e, -r);
}
var bn = 864e5;
function wn(e) {
  O(1, arguments);
  var t = E(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / bn) + 1;
}
function xe(e) {
  O(1, arguments);
  var t = 1, r = E(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function er(e) {
  O(1, arguments);
  var t = E(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = xe(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = xe(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Tn(e) {
  O(1, arguments);
  var t = er(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = xe(r);
  return n;
}
var _n = 6048e5;
function On(e) {
  O(1, arguments);
  var t = E(e), r = xe(t).getTime() - Tn(t).getTime();
  return Math.round(r / _n) + 1;
}
function Ae(e, t) {
  var r, n, a, i, o, s, u, l;
  O(1, arguments);
  var f = Le(), c = B((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : f.weekStartsOn) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = E(e), g = d.getUTCDay(), m = (g < c ? 7 : 0) + g - c;
  return d.setUTCDate(d.getUTCDate() - m), d.setUTCHours(0, 0, 0, 0), d;
}
function tr(e, t) {
  var r, n, a, i, o, s, u, l;
  O(1, arguments);
  var f = E(e), c = f.getUTCFullYear(), d = Le(), g = B((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(c + 1, 0, g), m.setUTCHours(0, 0, 0, 0);
  var T = Ae(m, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(c, 0, g), y.setUTCHours(0, 0, 0, 0);
  var w = Ae(y, t);
  return f.getTime() >= T.getTime() ? c + 1 : f.getTime() >= w.getTime() ? c : c - 1;
}
function Sn(e, t) {
  var r, n, a, i, o, s, u, l;
  O(1, arguments);
  var f = Le(), c = B((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), d = tr(e, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d, 0, c), g.setUTCHours(0, 0, 0, 0);
  var m = Ae(g, t);
  return m;
}
var $n = 6048e5;
function Pn(e, t) {
  O(1, arguments);
  var r = E(e), n = Ae(r, t).getTime() - Sn(r, t).getTime();
  return Math.round(n / $n) + 1;
}
function p(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var Cn = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return p(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : p(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return p(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return p(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return p(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return p(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return p(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return p(i, r.length);
  }
};
const N = Cn;
var V = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Mn = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return N.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = tr(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var s = o % 100;
      return p(s, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : p(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = er(t);
    return p(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return p(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return p(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return p(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return N.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return p(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = Pn(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : p(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = On(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : p(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : N.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = wn(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : p(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return p(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return p(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return p(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = V.noon : a === 0 ? i = V.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = V.evening : a >= 12 ? i = V.afternoon : a >= 4 ? i = V.morning : i = V.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return N.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : N.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : p(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : p(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : N.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : N.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return N.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return _t(o);
      case "XXXX":
      case "XX":
        return j(o);
      case "XXXXX":
      case "XXX":
      default:
        return j(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return _t(o);
      case "xxxx":
      case "xx":
        return j(o);
      case "xxxxx":
      case "xxx":
      default:
        return j(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Tt(o, ":");
      case "OOOO":
      default:
        return "GMT" + j(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Tt(o, ":");
      case "zzzz":
      default:
        return "GMT" + j(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return p(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return p(o, r.length);
  }
};
function Tt(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t || "";
  return r + String(a) + o + p(i, 2);
}
function _t(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + p(Math.abs(e) / 60, 2);
  }
  return j(e, t);
}
function j(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = p(Math.floor(a / 60), 2), o = p(a % 60, 2);
  return n + i + r + o;
}
const xn = Mn;
var Ot = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, rr = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, An = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return Ot(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Ot(a, r)).replace("{{time}}", rr(i, r));
}, En = {
  p: rr,
  P: An
};
const Dn = En;
var In = ["D", "DD"], Ln = ["YY", "YYYY"];
function Fn(e) {
  return In.indexOf(e) !== -1;
}
function Rn(e) {
  return Ln.indexOf(e) !== -1;
}
function St(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Un = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Nn = function(t, r, n) {
  var a, i = Un[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
const Wn = Nn;
var jn = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Yn = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Gn = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Bn = {
  date: Be({
    formats: jn,
    defaultWidth: "full"
  }),
  time: Be({
    formats: Yn,
    defaultWidth: "full"
  }),
  dateTime: Be({
    formats: Gn,
    defaultWidth: "full"
  })
};
const Hn = Bn;
var qn = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, zn = function(t, r, n, a) {
  return qn[t];
};
const Qn = zn;
var Xn = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, kn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Kn = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Vn = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Zn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Jn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ea = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ta = {
  ordinalNumber: ea,
  era: ue({
    values: Xn,
    defaultWidth: "wide"
  }),
  quarter: ue({
    values: kn,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ue({
    values: Kn,
    defaultWidth: "wide"
  }),
  day: ue({
    values: Vn,
    defaultWidth: "wide"
  }),
  dayPeriod: ue({
    values: Zn,
    defaultWidth: "wide",
    formattingValues: Jn,
    defaultFormattingWidth: "wide"
  })
};
const ra = ta;
var na = /^(\d+)(th|st|nd|rd)?/i, aa = /\d+/i, ia = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, oa = {
  any: [/^b/i, /^(a|c)/i]
}, sa = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ua = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, la = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ca = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, fa = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, da = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ha = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ga = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ma = {
  ordinalNumber: dn({
    matchPattern: na,
    parsePattern: aa,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: le({
    matchPatterns: ia,
    defaultMatchWidth: "wide",
    parsePatterns: oa,
    defaultParseWidth: "any"
  }),
  quarter: le({
    matchPatterns: sa,
    defaultMatchWidth: "wide",
    parsePatterns: ua,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: le({
    matchPatterns: la,
    defaultMatchWidth: "wide",
    parsePatterns: ca,
    defaultParseWidth: "any"
  }),
  day: le({
    matchPatterns: fa,
    defaultMatchWidth: "wide",
    parsePatterns: da,
    defaultParseWidth: "any"
  }),
  dayPeriod: le({
    matchPatterns: ha,
    defaultMatchWidth: "any",
    parsePatterns: ga,
    defaultParseWidth: "any"
  })
};
const pa = ma;
var va = {
  code: "en-US",
  formatDistance: Wn,
  formatLong: Hn,
  formatRelative: Qn,
  localize: ra,
  match: pa,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const nr = va;
var ya = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ba = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, wa = /^'([^]*?)'?$/, Ta = /''/g, _a = /[a-zA-Z]/;
function ke(e, t, r) {
  var n, a, i, o, s, u, l, f, c, d, g, m, T, y, w, C, k, R;
  O(2, arguments);
  var K = String(t), ie = Le(), oe = (n = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : ie.locale) !== null && n !== void 0 ? n : nr, Ye = B((i = (o = (s = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (l = r.locale) === null || l === void 0 || (f = l.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && s !== void 0 ? s : ie.firstWeekContainsDate) !== null && o !== void 0 ? o : (c = ie.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(Ye >= 1 && Ye <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var Ge = B((g = (m = (T = (y = r == null ? void 0 : r.weekStartsOn) !== null && y !== void 0 ? y : r == null || (w = r.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && T !== void 0 ? T : ie.weekStartsOn) !== null && m !== void 0 ? m : (k = ie.locale) === null || k === void 0 || (R = k.options) === null || R === void 0 ? void 0 : R.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(Ge >= 0 && Ge <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!oe.localize)
    throw new RangeError("locale must contain localize property");
  if (!oe.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var _e = E(e);
  if (!vn(_e))
    throw new RangeError("Invalid time value");
  var Qr = mn(_e), Xr = yn(_e, Qr), kr = {
    firstWeekContainsDate: Ye,
    weekStartsOn: Ge,
    locale: oe,
    _originalDate: _e
  }, Kr = K.match(ba).map(function($) {
    var U = $[0];
    if (U === "p" || U === "P") {
      var Oe = Dn[U];
      return Oe($, oe.formatLong);
    }
    return $;
  }).join("").match(ya).map(function($) {
    if ($ === "''")
      return "'";
    var U = $[0];
    if (U === "'")
      return Oa($);
    var Oe = xn[U];
    if (Oe)
      return !(r != null && r.useAdditionalWeekYearTokens) && Rn($) && St($, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && Fn($) && St($, t, String(e)), Oe(Xr, $, oe.localize, kr);
    if (U.match(_a))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + U + "`");
    return $;
  }).join("");
  return Kr;
}
function Oa(e) {
  var t = e.match(wa);
  return t ? t[1].replace(Ta, "'") : e;
}
var Sa = typeof global == "object" && global && global.Object === Object && global;
const ar = Sa;
var $a = typeof self == "object" && self && self.Object === Object && self, Pa = ar || $a || Function("return this")();
const D = Pa;
var Ca = D.Symbol;
const P = Ca;
var ir = Object.prototype, Ma = ir.hasOwnProperty, xa = ir.toString, ce = P ? P.toStringTag : void 0;
function Aa(e) {
  var t = Ma.call(e, ce), r = e[ce];
  try {
    e[ce] = void 0;
    var n = !0;
  } catch {
  }
  var a = xa.call(e);
  return n && (t ? e[ce] = r : delete e[ce]), a;
}
var Ea = Object.prototype, Da = Ea.toString;
function Ia(e) {
  return Da.call(e);
}
var La = "[object Null]", Fa = "[object Undefined]", $t = P ? P.toStringTag : void 0;
function z(e) {
  return e == null ? e === void 0 ? Fa : La : $t && $t in Object(e) ? Aa(e) : Ia(e);
}
function A(e) {
  return e != null && typeof e == "object";
}
var Ra = "[object Symbol]";
function nt(e) {
  return typeof e == "symbol" || A(e) && z(e) == Ra;
}
function Ua(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Na = Array.isArray;
const S = Na;
var Wa = 1 / 0, Pt = P ? P.prototype : void 0, Ct = Pt ? Pt.toString : void 0;
function or(e) {
  if (typeof e == "string")
    return e;
  if (S(e))
    return Ua(e, or) + "";
  if (nt(e))
    return Ct ? Ct.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Wa ? "-0" : t;
}
function I(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function at(e) {
  return e;
}
var ja = "[object AsyncFunction]", Ya = "[object Function]", Ga = "[object GeneratorFunction]", Ba = "[object Proxy]";
function it(e) {
  if (!I(e))
    return !1;
  var t = z(e);
  return t == Ya || t == Ga || t == ja || t == Ba;
}
var Ha = D["__core-js_shared__"];
const He = Ha;
var Mt = function() {
  var e = /[^.]+$/.exec(He && He.keys && He.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function qa(e) {
  return !!Mt && Mt in e;
}
var za = Function.prototype, Qa = za.toString;
function Q(e) {
  if (e != null) {
    try {
      return Qa.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Xa = /[\\^$.*+?()[\]{}|]/g, ka = /^\[object .+?Constructor\]$/, Ka = Function.prototype, Va = Object.prototype, Za = Ka.toString, Ja = Va.hasOwnProperty, ei = RegExp(
  "^" + Za.call(Ja).replace(Xa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ti(e) {
  if (!I(e) || qa(e))
    return !1;
  var t = it(e) ? ei : ka;
  return t.test(Q(e));
}
function ri(e, t) {
  return e == null ? void 0 : e[t];
}
function X(e, t) {
  var r = ri(e, t);
  return ti(r) ? r : void 0;
}
var ni = X(D, "WeakMap");
const Ke = ni;
var xt = Object.create, ai = function() {
  function e() {
  }
  return function(t) {
    if (!I(t))
      return {};
    if (xt)
      return xt(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const ii = ai;
function oi(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function si() {
}
function sr(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var ui = 800, li = 16, ci = Date.now;
function fi(e) {
  var t = 0, r = 0;
  return function() {
    var n = ci(), a = li - (n - r);
    if (r = n, a > 0) {
      if (++t >= ui)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function di(e) {
  return function() {
    return e;
  };
}
var hi = function() {
  try {
    var e = X(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Ee = hi;
var gi = Ee ? function(e, t) {
  return Ee(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: di(t),
    writable: !0
  });
} : at;
const mi = gi;
var pi = fi(mi);
const vi = pi;
function yi(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
function bi(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function wi(e) {
  return e !== e;
}
function Ti(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
function _i(e, t, r) {
  return t === t ? Ti(e, t, r) : bi(e, wi, r);
}
function Oi(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && _i(e, t, 0) > -1;
}
var Si = 9007199254740991, $i = /^(?:0|[1-9]\d*)$/;
function ot(e, t) {
  var r = typeof e;
  return t = t ?? Si, !!t && (r == "number" || r != "symbol" && $i.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function st(e, t, r) {
  t == "__proto__" && Ee ? Ee(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function pe(e, t) {
  return e === t || e !== e && t !== t;
}
var Pi = Object.prototype, Ci = Pi.hasOwnProperty;
function ur(e, t, r) {
  var n = e[t];
  (!(Ci.call(e, t) && pe(n, r)) || r === void 0 && !(t in e)) && st(e, t, r);
}
function ve(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], u = n ? n(r[s], e[s], s, r, e) : void 0;
    u === void 0 && (u = e[s]), a ? st(r, s, u) : ur(r, s, u);
  }
  return r;
}
var At = Math.max;
function Mi(e, t, r) {
  return t = At(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = At(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), oi(e, this, s);
  };
}
function lr(e, t) {
  return vi(Mi(e, t, at), e + "");
}
var xi = 9007199254740991;
function ut(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= xi;
}
function ye(e) {
  return e != null && ut(e.length) && !it(e);
}
function Ai(e, t, r) {
  if (!I(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? ye(r) && ot(t, r.length) : n == "string" && t in r) ? pe(r[t], e) : !1;
}
function Ei(e) {
  return lr(function(t, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && Ai(r[0], r[1], o) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++n < a; ) {
      var s = r[n];
      s && e(t, s, n, i);
    }
    return t;
  });
}
var Di = Object.prototype;
function Fe(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Di;
  return e === r;
}
function Ii(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Li = "[object Arguments]";
function Et(e) {
  return A(e) && z(e) == Li;
}
var cr = Object.prototype, Fi = cr.hasOwnProperty, Ri = cr.propertyIsEnumerable, Ui = Et(function() {
  return arguments;
}()) ? Et : function(e) {
  return A(e) && Fi.call(e, "callee") && !Ri.call(e, "callee");
};
const ee = Ui;
function Ni() {
  return !1;
}
var fr = typeof exports == "object" && exports && !exports.nodeType && exports, Dt = fr && typeof module == "object" && module && !module.nodeType && module, Wi = Dt && Dt.exports === fr, It = Wi ? D.Buffer : void 0, ji = It ? It.isBuffer : void 0, Yi = ji || Ni;
const te = Yi;
var Gi = "[object Arguments]", Bi = "[object Array]", Hi = "[object Boolean]", qi = "[object Date]", zi = "[object Error]", Qi = "[object Function]", Xi = "[object Map]", ki = "[object Number]", Ki = "[object Object]", Vi = "[object RegExp]", Zi = "[object Set]", Ji = "[object String]", eo = "[object WeakMap]", to = "[object ArrayBuffer]", ro = "[object DataView]", no = "[object Float32Array]", ao = "[object Float64Array]", io = "[object Int8Array]", oo = "[object Int16Array]", so = "[object Int32Array]", uo = "[object Uint8Array]", lo = "[object Uint8ClampedArray]", co = "[object Uint16Array]", fo = "[object Uint32Array]", b = {};
b[no] = b[ao] = b[io] = b[oo] = b[so] = b[uo] = b[lo] = b[co] = b[fo] = !0;
b[Gi] = b[Bi] = b[to] = b[Hi] = b[ro] = b[qi] = b[zi] = b[Qi] = b[Xi] = b[ki] = b[Ki] = b[Vi] = b[Zi] = b[Ji] = b[eo] = !1;
function ho(e) {
  return A(e) && ut(e.length) && !!b[z(e)];
}
function lt(e) {
  return function(t) {
    return e(t);
  };
}
var dr = typeof exports == "object" && exports && !exports.nodeType && exports, de = dr && typeof module == "object" && module && !module.nodeType && module, go = de && de.exports === dr, qe = go && ar.process, mo = function() {
  try {
    var e = de && de.require && de.require("util").types;
    return e || qe && qe.binding && qe.binding("util");
  } catch {
  }
}();
const re = mo;
var Lt = re && re.isTypedArray, po = Lt ? lt(Lt) : ho;
const Re = po;
var vo = Object.prototype, yo = vo.hasOwnProperty;
function hr(e, t) {
  var r = S(e), n = !r && ee(e), a = !r && !n && te(e), i = !r && !n && !a && Re(e), o = r || n || a || i, s = o ? Ii(e.length, String) : [], u = s.length;
  for (var l in e)
    (t || yo.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    ot(l, u))) && s.push(l);
  return s;
}
function gr(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var bo = gr(Object.keys, Object);
const wo = bo;
var To = Object.prototype, _o = To.hasOwnProperty;
function mr(e) {
  if (!Fe(e))
    return wo(e);
  var t = [];
  for (var r in Object(e))
    _o.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Ue(e) {
  return ye(e) ? hr(e) : mr(e);
}
function Oo(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var So = Object.prototype, $o = So.hasOwnProperty;
function Po(e) {
  if (!I(e))
    return Oo(e);
  var t = Fe(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !$o.call(e, n)) || r.push(n);
  return r;
}
function be(e) {
  return ye(e) ? hr(e, !0) : Po(e);
}
var Co = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Mo = /^\w*$/;
function ct(e, t) {
  if (S(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || nt(e) ? !0 : Mo.test(e) || !Co.test(e) || t != null && e in Object(t);
}
var xo = X(Object, "create");
const he = xo;
function Ao() {
  this.__data__ = he ? he(null) : {}, this.size = 0;
}
function Eo(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Do = "__lodash_hash_undefined__", Io = Object.prototype, Lo = Io.hasOwnProperty;
function Fo(e) {
  var t = this.__data__;
  if (he) {
    var r = t[e];
    return r === Do ? void 0 : r;
  }
  return Lo.call(t, e) ? t[e] : void 0;
}
var Ro = Object.prototype, Uo = Ro.hasOwnProperty;
function No(e) {
  var t = this.__data__;
  return he ? t[e] !== void 0 : Uo.call(t, e);
}
var Wo = "__lodash_hash_undefined__";
function jo(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = he && t === void 0 ? Wo : t, this;
}
function H(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
H.prototype.clear = Ao;
H.prototype.delete = Eo;
H.prototype.get = Fo;
H.prototype.has = No;
H.prototype.set = jo;
function Yo() {
  this.__data__ = [], this.size = 0;
}
function Ne(e, t) {
  for (var r = e.length; r--; )
    if (pe(e[r][0], t))
      return r;
  return -1;
}
var Go = Array.prototype, Bo = Go.splice;
function Ho(e) {
  var t = this.__data__, r = Ne(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Bo.call(t, r, 1), --this.size, !0;
}
function qo(e) {
  var t = this.__data__, r = Ne(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function zo(e) {
  return Ne(this.__data__, e) > -1;
}
function Qo(e, t) {
  var r = this.__data__, n = Ne(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function L(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
L.prototype.clear = Yo;
L.prototype.delete = Ho;
L.prototype.get = qo;
L.prototype.has = zo;
L.prototype.set = Qo;
var Xo = X(D, "Map");
const ge = Xo;
function ko() {
  this.size = 0, this.__data__ = {
    hash: new H(),
    map: new (ge || L)(),
    string: new H()
  };
}
function Ko(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function We(e, t) {
  var r = e.__data__;
  return Ko(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Vo(e) {
  var t = We(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Zo(e) {
  return We(this, e).get(e);
}
function Jo(e) {
  return We(this, e).has(e);
}
function es(e, t) {
  var r = We(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function F(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
F.prototype.clear = ko;
F.prototype.delete = Vo;
F.prototype.get = Zo;
F.prototype.has = Jo;
F.prototype.set = es;
var ts = "Expected a function";
function ft(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(ts);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (ft.Cache || F)(), r;
}
ft.Cache = F;
var rs = 500;
function ns(e) {
  var t = ft(e, function(n) {
    return r.size === rs && r.clear(), n;
  }), r = t.cache;
  return t;
}
var as = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, is = /\\(\\)?/g, os = ns(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(as, function(r, n, a, i) {
    t.push(a ? i.replace(is, "$1") : n || r);
  }), t;
});
const ss = os;
function us(e) {
  return e == null ? "" : or(e);
}
function pr(e, t) {
  return S(e) ? e : ct(e, t) ? [e] : ss(us(e));
}
var ls = 1 / 0;
function je(e) {
  if (typeof e == "string" || nt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -ls ? "-0" : t;
}
function vr(e, t) {
  t = pr(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[je(t[r++])];
  return r && r == n ? e : void 0;
}
function cs(e, t, r) {
  var n = e == null ? void 0 : vr(e, t);
  return n === void 0 ? r : n;
}
function dt(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var Ft = P ? P.isConcatSpreadable : void 0;
function fs(e) {
  return S(e) || ee(e) || !!(Ft && e && e[Ft]);
}
function yr(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = fs), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && r(s) ? t > 1 ? yr(s, t - 1, r, n, a) : dt(a, s) : n || (a[a.length] = s);
  }
  return a;
}
var ds = gr(Object.getPrototypeOf, Object);
const ht = ds;
var hs = "[object Object]", gs = Function.prototype, ms = Object.prototype, br = gs.toString, ps = ms.hasOwnProperty, vs = br.call(Object);
function ys(e) {
  if (!A(e) || z(e) != hs)
    return !1;
  var t = ht(e);
  if (t === null)
    return !0;
  var r = ps.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && br.call(r) == vs;
}
function bs() {
  this.__data__ = new L(), this.size = 0;
}
function ws(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Ts(e) {
  return this.__data__.get(e);
}
function _s(e) {
  return this.__data__.has(e);
}
var Os = 200;
function Ss(e, t) {
  var r = this.__data__;
  if (r instanceof L) {
    var n = r.__data__;
    if (!ge || n.length < Os - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new F(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function M(e) {
  var t = this.__data__ = new L(e);
  this.size = t.size;
}
M.prototype.clear = bs;
M.prototype.delete = ws;
M.prototype.get = Ts;
M.prototype.has = _s;
M.prototype.set = Ss;
function $s(e, t) {
  return e && ve(t, Ue(t), e);
}
function Ps(e, t) {
  return e && ve(t, be(t), e);
}
var wr = typeof exports == "object" && exports && !exports.nodeType && exports, Rt = wr && typeof module == "object" && module && !module.nodeType && module, Cs = Rt && Rt.exports === wr, Ut = Cs ? D.Buffer : void 0, Nt = Ut ? Ut.allocUnsafe : void 0;
function Tr(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = Nt ? Nt(r) : new e.constructor(r);
  return e.copy(n), n;
}
function Ms(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
function _r() {
  return [];
}
var xs = Object.prototype, As = xs.propertyIsEnumerable, Wt = Object.getOwnPropertySymbols, Es = Wt ? function(e) {
  return e == null ? [] : (e = Object(e), Ms(Wt(e), function(t) {
    return As.call(e, t);
  }));
} : _r;
const gt = Es;
function Ds(e, t) {
  return ve(e, gt(e), t);
}
var Is = Object.getOwnPropertySymbols, Ls = Is ? function(e) {
  for (var t = []; e; )
    dt(t, gt(e)), e = ht(e);
  return t;
} : _r;
const Or = Ls;
function Fs(e, t) {
  return ve(e, Or(e), t);
}
function Sr(e, t, r) {
  var n = t(e);
  return S(e) ? n : dt(n, r(e));
}
function Ve(e) {
  return Sr(e, Ue, gt);
}
function Rs(e) {
  return Sr(e, be, Or);
}
var Us = X(D, "DataView");
const Ze = Us;
var Ns = X(D, "Promise");
const Je = Ns;
var Ws = X(D, "Set");
const J = Ws;
var jt = "[object Map]", js = "[object Object]", Yt = "[object Promise]", Gt = "[object Set]", Bt = "[object WeakMap]", Ht = "[object DataView]", Ys = Q(Ze), Gs = Q(ge), Bs = Q(Je), Hs = Q(J), qs = Q(Ke), Y = z;
(Ze && Y(new Ze(new ArrayBuffer(1))) != Ht || ge && Y(new ge()) != jt || Je && Y(Je.resolve()) != Yt || J && Y(new J()) != Gt || Ke && Y(new Ke()) != Bt) && (Y = function(e) {
  var t = z(e), r = t == js ? e.constructor : void 0, n = r ? Q(r) : "";
  if (n)
    switch (n) {
      case Ys:
        return Ht;
      case Gs:
        return jt;
      case Bs:
        return Yt;
      case Hs:
        return Gt;
      case qs:
        return Bt;
    }
  return t;
});
const ne = Y;
var zs = Object.prototype, Qs = zs.hasOwnProperty;
function Xs(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && Qs.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var ks = D.Uint8Array;
const De = ks;
function mt(e) {
  var t = new e.constructor(e.byteLength);
  return new De(t).set(new De(e)), t;
}
function Ks(e, t) {
  var r = t ? mt(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var Vs = /\w*$/;
function Zs(e) {
  var t = new e.constructor(e.source, Vs.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var qt = P ? P.prototype : void 0, zt = qt ? qt.valueOf : void 0;
function Js(e) {
  return zt ? Object(zt.call(e)) : {};
}
function $r(e, t) {
  var r = t ? mt(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var eu = "[object Boolean]", tu = "[object Date]", ru = "[object Map]", nu = "[object Number]", au = "[object RegExp]", iu = "[object Set]", ou = "[object String]", su = "[object Symbol]", uu = "[object ArrayBuffer]", lu = "[object DataView]", cu = "[object Float32Array]", fu = "[object Float64Array]", du = "[object Int8Array]", hu = "[object Int16Array]", gu = "[object Int32Array]", mu = "[object Uint8Array]", pu = "[object Uint8ClampedArray]", vu = "[object Uint16Array]", yu = "[object Uint32Array]";
function bu(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case uu:
      return mt(e);
    case eu:
    case tu:
      return new n(+e);
    case lu:
      return Ks(e, r);
    case cu:
    case fu:
    case du:
    case hu:
    case gu:
    case mu:
    case pu:
    case vu:
    case yu:
      return $r(e, r);
    case ru:
      return new n();
    case nu:
    case ou:
      return new n(e);
    case au:
      return Zs(e);
    case iu:
      return new n();
    case su:
      return Js(e);
  }
}
function Pr(e) {
  return typeof e.constructor == "function" && !Fe(e) ? ii(ht(e)) : {};
}
var wu = "[object Map]";
function Tu(e) {
  return A(e) && ne(e) == wu;
}
var Qt = re && re.isMap, _u = Qt ? lt(Qt) : Tu;
const Ou = _u;
var Su = "[object Set]";
function $u(e) {
  return A(e) && ne(e) == Su;
}
var Xt = re && re.isSet, Pu = Xt ? lt(Xt) : $u;
const Cu = Pu;
var Mu = 1, xu = 2, Au = 4, Cr = "[object Arguments]", Eu = "[object Array]", Du = "[object Boolean]", Iu = "[object Date]", Lu = "[object Error]", Mr = "[object Function]", Fu = "[object GeneratorFunction]", Ru = "[object Map]", Uu = "[object Number]", xr = "[object Object]", Nu = "[object RegExp]", Wu = "[object Set]", ju = "[object String]", Yu = "[object Symbol]", Gu = "[object WeakMap]", Bu = "[object ArrayBuffer]", Hu = "[object DataView]", qu = "[object Float32Array]", zu = "[object Float64Array]", Qu = "[object Int8Array]", Xu = "[object Int16Array]", ku = "[object Int32Array]", Ku = "[object Uint8Array]", Vu = "[object Uint8ClampedArray]", Zu = "[object Uint16Array]", Ju = "[object Uint32Array]", v = {};
v[Cr] = v[Eu] = v[Bu] = v[Hu] = v[Du] = v[Iu] = v[qu] = v[zu] = v[Qu] = v[Xu] = v[ku] = v[Ru] = v[Uu] = v[xr] = v[Nu] = v[Wu] = v[ju] = v[Yu] = v[Ku] = v[Vu] = v[Zu] = v[Ju] = !0;
v[Lu] = v[Mr] = v[Gu] = !1;
function Ce(e, t, r, n, a, i) {
  var o, s = t & Mu, u = t & xu, l = t & Au;
  if (r && (o = a ? r(e, n, a, i) : r(e)), o !== void 0)
    return o;
  if (!I(e))
    return e;
  var f = S(e);
  if (f) {
    if (o = Xs(e), !s)
      return sr(e, o);
  } else {
    var c = ne(e), d = c == Mr || c == Fu;
    if (te(e))
      return Tr(e, s);
    if (c == xr || c == Cr || d && !a) {
      if (o = u || d ? {} : Pr(e), !s)
        return u ? Fs(e, Ps(o, e)) : Ds(e, $s(o, e));
    } else {
      if (!v[c])
        return a ? e : {};
      o = bu(e, c, s);
    }
  }
  i || (i = new M());
  var g = i.get(e);
  if (g)
    return g;
  i.set(e, o), Cu(e) ? e.forEach(function(y) {
    o.add(Ce(y, t, r, y, e, i));
  }) : Ou(e) && e.forEach(function(y, w) {
    o.set(w, Ce(y, t, r, w, e, i));
  });
  var m = l ? u ? Rs : Ve : u ? be : Ue, T = f ? void 0 : m(e);
  return yi(T || e, function(y, w) {
    T && (w = y, y = e[w]), ur(o, w, Ce(y, t, r, w, e, i));
  }), o;
}
var el = 1, tl = 4;
function rl(e) {
  return Ce(e, el | tl);
}
var nl = "__lodash_hash_undefined__";
function al(e) {
  return this.__data__.set(e, nl), this;
}
function il(e) {
  return this.__data__.has(e);
}
function me(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new F(); ++t < r; )
    this.add(e[t]);
}
me.prototype.add = me.prototype.push = al;
me.prototype.has = il;
function ol(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function Ar(e, t) {
  return e.has(t);
}
var sl = 1, ul = 2;
function Er(e, t, r, n, a, i) {
  var o = r & sl, s = e.length, u = t.length;
  if (s != u && !(o && u > s))
    return !1;
  var l = i.get(e), f = i.get(t);
  if (l && f)
    return l == t && f == e;
  var c = -1, d = !0, g = r & ul ? new me() : void 0;
  for (i.set(e, t), i.set(t, e); ++c < s; ) {
    var m = e[c], T = t[c];
    if (n)
      var y = o ? n(T, m, c, t, e, i) : n(m, T, c, e, t, i);
    if (y !== void 0) {
      if (y)
        continue;
      d = !1;
      break;
    }
    if (g) {
      if (!ol(t, function(w, C) {
        if (!Ar(g, C) && (m === w || a(m, w, r, n, i)))
          return g.push(C);
      })) {
        d = !1;
        break;
      }
    } else if (!(m === T || a(m, T, r, n, i))) {
      d = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), d;
}
function ll(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function pt(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var cl = 1, fl = 2, dl = "[object Boolean]", hl = "[object Date]", gl = "[object Error]", ml = "[object Map]", pl = "[object Number]", vl = "[object RegExp]", yl = "[object Set]", bl = "[object String]", wl = "[object Symbol]", Tl = "[object ArrayBuffer]", _l = "[object DataView]", kt = P ? P.prototype : void 0, ze = kt ? kt.valueOf : void 0;
function Ol(e, t, r, n, a, i, o) {
  switch (r) {
    case _l:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Tl:
      return !(e.byteLength != t.byteLength || !i(new De(e), new De(t)));
    case dl:
    case hl:
    case pl:
      return pe(+e, +t);
    case gl:
      return e.name == t.name && e.message == t.message;
    case vl:
    case bl:
      return e == t + "";
    case ml:
      var s = ll;
    case yl:
      var u = n & cl;
      if (s || (s = pt), e.size != t.size && !u)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= fl, o.set(e, t);
      var f = Er(s(e), s(t), n, a, i, o);
      return o.delete(e), f;
    case wl:
      if (ze)
        return ze.call(e) == ze.call(t);
  }
  return !1;
}
var Sl = 1, $l = Object.prototype, Pl = $l.hasOwnProperty;
function Cl(e, t, r, n, a, i) {
  var o = r & Sl, s = Ve(e), u = s.length, l = Ve(t), f = l.length;
  if (u != f && !o)
    return !1;
  for (var c = u; c--; ) {
    var d = s[c];
    if (!(o ? d in t : Pl.call(t, d)))
      return !1;
  }
  var g = i.get(e), m = i.get(t);
  if (g && m)
    return g == t && m == e;
  var T = !0;
  i.set(e, t), i.set(t, e);
  for (var y = o; ++c < u; ) {
    d = s[c];
    var w = e[d], C = t[d];
    if (n)
      var k = o ? n(C, w, d, t, e, i) : n(w, C, d, e, t, i);
    if (!(k === void 0 ? w === C || a(w, C, r, n, i) : k)) {
      T = !1;
      break;
    }
    y || (y = d == "constructor");
  }
  if (T && !y) {
    var R = e.constructor, K = t.constructor;
    R != K && "constructor" in e && "constructor" in t && !(typeof R == "function" && R instanceof R && typeof K == "function" && K instanceof K) && (T = !1);
  }
  return i.delete(e), i.delete(t), T;
}
var Ml = 1, Kt = "[object Arguments]", Vt = "[object Array]", Se = "[object Object]", xl = Object.prototype, Zt = xl.hasOwnProperty;
function Al(e, t, r, n, a, i) {
  var o = S(e), s = S(t), u = o ? Vt : ne(e), l = s ? Vt : ne(t);
  u = u == Kt ? Se : u, l = l == Kt ? Se : l;
  var f = u == Se, c = l == Se, d = u == l;
  if (d && te(e)) {
    if (!te(t))
      return !1;
    o = !0, f = !1;
  }
  if (d && !f)
    return i || (i = new M()), o || Re(e) ? Er(e, t, r, n, a, i) : Ol(e, t, u, r, n, a, i);
  if (!(r & Ml)) {
    var g = f && Zt.call(e, "__wrapped__"), m = c && Zt.call(t, "__wrapped__");
    if (g || m) {
      var T = g ? e.value() : e, y = m ? t.value() : t;
      return i || (i = new M()), a(T, y, r, n, i);
    }
  }
  return d ? (i || (i = new M()), Cl(e, t, r, n, a, i)) : !1;
}
function vt(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !A(e) && !A(t) ? e !== e && t !== t : Al(e, t, r, n, vt, a);
}
var El = 1, Dl = 2;
function Il(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var u = s[0], l = e[u], f = s[1];
    if (o && s[2]) {
      if (l === void 0 && !(u in e))
        return !1;
    } else {
      var c = new M();
      if (n)
        var d = n(l, f, u, e, t, c);
      if (!(d === void 0 ? vt(f, l, El | Dl, n, c) : d))
        return !1;
    }
  }
  return !0;
}
function Dr(e) {
  return e === e && !I(e);
}
function Ll(e) {
  for (var t = Ue(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, Dr(a)];
  }
  return t;
}
function Ir(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function Fl(e) {
  var t = Ll(e);
  return t.length == 1 && t[0][2] ? Ir(t[0][0], t[0][1]) : function(r) {
    return r === e || Il(r, e, t);
  };
}
function Rl(e, t) {
  return e != null && t in Object(e);
}
function Ul(e, t, r) {
  t = pr(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = je(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && ut(a) && ot(o, a) && (S(e) || ee(e)));
}
function Nl(e, t) {
  return e != null && Ul(e, t, Rl);
}
var Wl = 1, jl = 2;
function Yl(e, t) {
  return ct(e) && Dr(t) ? Ir(je(e), t) : function(r) {
    var n = cs(r, e);
    return n === void 0 && n === t ? Nl(r, e) : vt(t, n, Wl | jl);
  };
}
function Gl(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Bl(e) {
  return function(t) {
    return vr(t, e);
  };
}
function Hl(e) {
  return ct(e) ? Gl(je(e)) : Bl(e);
}
function ql(e) {
  return typeof e == "function" ? e : e == null ? at : typeof e == "object" ? S(e) ? Yl(e[0], e[1]) : Fl(e) : Hl(e);
}
function zl(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var u = o[e ? s : ++a];
      if (r(i[u], u, i) === !1)
        break;
    }
    return t;
  };
}
var Ql = zl();
const Xl = Ql;
function et(e, t, r) {
  (r !== void 0 && !pe(e[t], r) || r === void 0 && !(t in e)) && st(e, t, r);
}
function tt(e) {
  return A(e) && ye(e);
}
function rt(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function kl(e) {
  return ve(e, be(e));
}
function Kl(e, t, r, n, a, i, o) {
  var s = rt(e, r), u = rt(t, r), l = o.get(u);
  if (l) {
    et(e, r, l);
    return;
  }
  var f = i ? i(s, u, r + "", e, t, o) : void 0, c = f === void 0;
  if (c) {
    var d = S(u), g = !d && te(u), m = !d && !g && Re(u);
    f = u, d || g || m ? S(s) ? f = s : tt(s) ? f = sr(s) : g ? (c = !1, f = Tr(u, !0)) : m ? (c = !1, f = $r(u, !0)) : f = [] : ys(u) || ee(u) ? (f = s, ee(s) ? f = kl(s) : (!I(s) || it(s)) && (f = Pr(u))) : c = !1;
  }
  c && (o.set(u, f), a(f, u, n, i, o), o.delete(u)), et(e, r, f);
}
function Lr(e, t, r, n, a) {
  e !== t && Xl(t, function(i, o) {
    if (a || (a = new M()), I(i))
      Kl(e, t, o, r, Lr, n, a);
    else {
      var s = n ? n(rt(e, o), i, o + "", e, t, a) : void 0;
      s === void 0 && (s = i), et(e, o, s);
    }
  }, be);
}
function Vl(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
function Zl(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Jl = "[object Map]", ec = "[object Set]", tc = Object.prototype, rc = tc.hasOwnProperty;
function nc(e) {
  if (e == null)
    return !0;
  if (ye(e) && (S(e) || typeof e == "string" || typeof e.splice == "function" || te(e) || Re(e) || ee(e)))
    return !e.length;
  var t = ne(e);
  if (t == Jl || t == ec)
    return !e.size;
  if (Fe(e))
    return !mr(e).length;
  for (var r in e)
    if (rc.call(e, r))
      return !1;
  return !0;
}
var ac = Ei(function(e, t, r) {
  Lr(e, t, r);
});
const h = ac;
var ic = 1 / 0, oc = J && 1 / pt(new J([, -0]))[1] == ic ? function(e) {
  return new J(e);
} : si;
const sc = oc;
var uc = 200;
function Fr(e, t, r) {
  var n = -1, a = Oi, i = e.length, o = !0, s = [], u = s;
  if (r)
    o = !1, a = Vl;
  else if (i >= uc) {
    var l = t ? null : sc(e);
    if (l)
      return pt(l);
    o = !1, a = Ar, u = new me();
  } else
    u = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var f = e[n], c = t ? t(f) : f;
      if (f = r || f !== 0 ? f : 0, o && c === c) {
        for (var d = u.length; d--; )
          if (u[d] === c)
            continue e;
        t && u.push(c), s.push(f);
      } else
        a(u, c, r) || (u !== s && u.push(c), s.push(f));
    }
  return s;
}
var lc = lr(function(e) {
  var t = Zl(e);
  return tt(t) && (t = void 0), Fr(yr(e, 1, tt, !0), ql(t));
});
const cc = lc;
function lf(e) {
  return e && e.length ? Fr(e) : [];
}
const fc = "cds", dc = {
  opacity: {
    unselected: 0.05,
    selected: 0.4
  }
}, hc = {
  ticks: {
    number: 7,
    rotateIfSmallerThan: 30,
    verticalSpaceRatio: 2.5,
    horizontalSpaceRatio: 3.5
  },
  ratio: {
    reference: "value",
    compareTo: "marker"
  },
  paddingRatio: 0.1,
  hover: {
    rectanglePadding: 4
  }
}, gc = {
  duration: 1e3,
  ease: nn,
  zoomLevel: 3
}, Rr = {
  circles: {
    fillOpacity: 0.3,
    hover: {
      stroke: "#FFF"
    }
  },
  padding: {
    mainGroup: 4,
    children: 2
  },
  hierarchyLevel: 2
}, mc = {
  pairingOptions: {
    "1-color": 4,
    "2-color": 5,
    "3-color": 5,
    "4-color": 3,
    "5-color": 2,
    "14-color": 1
  }
}, pc = {
  circle: {
    radius: 4,
    opacity: {
      hovered: 1,
      default: 0.3
    }
  },
  box: {
    opacity: {
      hovered: 0.5,
      default: 0.3
    }
  },
  strokeWidth: {
    default: 1,
    thicker: 2
  }
}, vc = {
  defaultBins: 10
}, yc = {
  items: {
    status: {
      ACTIVE: 1,
      DISABLED: 0
    },
    horizontalSpace: 12,
    verticalSpace: 24,
    textYOffset: 8,
    spaceAfter: 4
  },
  checkbox: {
    radius: 6.5
  },
  radius: {
    iconData: [
      { cx: 7, cy: 7, r: 6.5 },
      { cx: 7, cy: 10, r: 3.5 }
    ],
    fill: null,
    stroke: "#8c8c8c"
  },
  line: {
    yPosition: 6,
    width: 24,
    strokeWidth: 1.4,
    fill: null,
    stroke: "#999999"
  },
  area: {
    width: 24,
    height: 14,
    fill: "#6f6f6f",
    stroke: null
  },
  size: {
    iconData: [
      { width: 23, height: 12 },
      { width: 13, height: 6 }
    ],
    fill: null,
    stroke: "#8D8D8D"
  },
  quartile: {
    iconData: [
      { x: 0, y: 0, width: 24, height: 13 },
      { x: 11, y: 4, width: 1, height: 4 }
    ]
  },
  zoom: {
    iconData: [{ x: 0, y: 0, width: 12, height: 12 }],
    color: "#8D8D8D"
  },
  color: {
    barWidth: 300,
    barHeight: 8,
    axisYTranslation: 10
  }
}, bc = {
  opacity: {
    unselected: 0.3,
    selected: 1
  },
  weight: {
    selected: 2,
    unselected: 1
  }
}, wc = {
  statusBar: {
    paddingRight: 5
  },
  status: {
    indicatorSize: 16,
    paddingLeft: 15
  },
  total: {
    paddingLeft: 36,
    paddingRight: 24
  },
  height: {
    default: 8,
    proportional: 16
  },
  dividerWidth: 2
}, Tc = {
  radiusOffset: -15,
  innerRadius: 2,
  padAngle: 7e-3,
  hoverArc: {
    outerRadiusOffset: 3
  },
  xOffset: 30,
  yOffset: 20,
  yOffsetCallout: 10,
  callout: {
    minSliceDegree: 5,
    offsetX: 15,
    offsetY: 12,
    horizontalLineLength: 8,
    textMargin: 2
  }
}, _c = {
  opacity: {
    unselected: 0.1,
    selected: 0.3
  },
  xLabelPadding: 10,
  yLabelPadding: 8,
  yTicksNumber: 4,
  minRange: 10,
  xAxisRectHeight: 50,
  dotsRadius: 5
}, Oc = {
  nodeWidth: 4,
  nodeHoveredWidth: 8,
  minNodePadding: 24,
  opacity: {
    unfocus: 0.3,
    default: 0.8,
    selected: 1
  }
}, Sc = {
  minCellDividerDimension: 16,
  // Ensures axes lines are displayed with or without stroke disabled
  chartPadding: 0.5
}, $c = {
  default: {
    size: 24
  }
}, Pc = {
  horizontalOffset: 10
}, Cc = {
  default: {
    duration: 300
  },
  pie_slice_mouseover: {
    duration: 100
  },
  pie_chart_titles: {
    duration: 375
  },
  graph_element_mouseover_fill_update: {
    duration: 100
  },
  graph_element_mouseout_fill_update: {
    duration: 100
  }
}, Mc = {
  buttonSize: 32,
  iconSize: 20,
  height: 32,
  spacerHeight: 10,
  iconPadding: 6
}, xc = {
  height: {
    [Xe.GRAPH_VIEW]: 32,
    [Xe.SLIDER_VIEW]: 10
  },
  spacerHeight: 8,
  handleWidth: 5,
  handleBarWidth: 1,
  handleBarHeight: 12
}, Ur = [
  {
    type: x.RADIUS,
    name: "Radius"
  },
  {
    type: x.AREA,
    name: "Poor area"
  },
  {
    type: x.AREA,
    name: "Satisfactory area"
  },
  {
    type: x.AREA,
    name: "Great area"
  },
  {
    type: x.QUARTILE,
    name: "Quartiles"
  }
], Z = {
  type: Pe.END_LINE,
  threshold: 16,
  numCharacter: 14
}, Ac = {
  enabled: !0,
  position: Vr.BOTTOM,
  clickable: !0,
  truncation: Z,
  alignment: ae.LEFT,
  order: null,
  additionalItems: []
}, Nr = {
  x: {
    // set enable to false will not draw grid and stroke of grid backdrop
    enabled: !0,
    numberOfTicks: 15,
    alignWithAxisTicks: !1
  },
  y: {
    // set enable to false will not draw grid and stroke of grid backdrop
    enabled: !0,
    numberOfTicks: 5,
    alignWithAxisTicks: !1
  }
}, Wr = {
  // enable or disable ruler
  enabled: !0
}, yt = {
  enabled: !0,
  showTotal: !0,
  truncation: Z,
  groupLabel: "Group"
}, jr = {
  top: {
    visible: !0,
    includeZero: !0,
    truncation: Z
  },
  bottom: {
    visible: !0,
    includeZero: !0,
    truncation: Z
  },
  left: {
    visible: !0,
    includeZero: !0,
    truncation: Z
  },
  right: {
    visible: !0,
    includeZero: !0,
    truncation: Z
  }
}, we = {
  addSpaceOnEdges: 1,
  showDayName: !1,
  localeObject: nr,
  timeIntervalFormats: {
    "15seconds": { primary: "MMM d, pp", secondary: "pp" },
    minute: { primary: "MMM d, p", secondary: "p" },
    "30minutes": { primary: "MMM d, p", secondary: "p" },
    hourly: { primary: "MMM d, hh a", secondary: "hh a" },
    daily: { primary: "MMM d", secondary: "d" },
    weekly: { primary: "eee, MMM d", secondary: "eee" },
    monthly: { primary: "MMM yyyy", secondary: "MMM" },
    quarterly: { primary: "QQQ ''yy", secondary: "QQQ" },
    yearly: { primary: "yyyy", secondary: "yyyy" }
  }
}, Ec = typeof document < "u" && (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled), _ = {
  width: null,
  height: null,
  resizable: !0,
  theme: Zr.WHITE,
  tooltip: yt,
  legend: Ac,
  style: {
    prefix: "cc"
  },
  data: {
    groupMapsTo: "group",
    loading: !1,
    selectedGroups: []
  },
  color: {
    scale: null,
    pairing: {
      numberOfVariants: null,
      option: 1
    },
    gradient: {
      enabled: !1
    }
  },
  toolbar: {
    enabled: !0,
    numberOfIcons: 3,
    controls: [
      {
        type: se.SHOW_AS_DATATABLE
      },
      ...Ec ? [
        {
          type: se.MAKE_FULLSCREEN
        }
      ] : [],
      {
        type: se.EXPORT_CSV
      },
      {
        type: se.EXPORT_PNG
      },
      {
        type: se.EXPORT_JPG
      }
    ]
  }
}, Yr = h({}, _, {
  thematic: {
    projection: Jr.geoNaturalEarth1
  }
}), Te = h({}, _, {
  axes: jr,
  timeScale: we,
  grid: Nr,
  ruler: Wr,
  zoomBar: {
    zoomRatio: 0.4,
    minZoomRatio: 0.01,
    top: {
      enabled: !1,
      type: Xe.GRAPH_VIEW
    }
  }
}), q = h({}, Te, {
  bars: {
    maxWidth: 16,
    spacingFactor: 0.25
  },
  timeScale: h(we, {
    addSpaceOnEdges: 1
  })
}), Dc = h({}, q, {}), Ic = h({}, q, {}), Lc = h({}, q, {
  bars: h({}, q.bars, {
    dividerSize: 1.5
  })
}), Fc = h({}, q, {}), bt = h({}, Te, {
  points: {
    // default point radius to 4
    radius: 4,
    fillOpacity: 0.3,
    filled: !0,
    enabled: !0
  }
}), Rc = bt, Gr = h({}, bt, {
  points: {
    // default point radius to 3
    radius: 3,
    filled: !1,
    enabled: !0
  }
}), Br = h({}, Gr, {
  timeScale: h(we, {
    addSpaceOnEdges: 0
  })
}), Uc = Br, Nc = h({}, Te, {
  bubble: {
    radiusMapsTo: "radius",
    radiusLabel: "Radius",
    radiusRange: (e) => {
      const t = Math.min(e.width, e.height);
      return [t * 3 / 400, t * 25 / 400];
    },
    fillOpacity: 0.2,
    enabled: !0
  },
  points: {
    filled: !0
  },
  legend: {
    additionalItems: [
      {
        type: x.RADIUS,
        name: "Radius"
      }
    ]
  }
}), Wc = h({}, Te, {
  bullet: {
    performanceAreaTitles: ["Poor", "Satisfactory", "Great"]
  },
  grid: {
    x: {
      enabled: !1
    },
    y: {
      enabled: !1
    }
  },
  legend: {
    additionalItems: [
      {
        type: x.AREA,
        name: "Poor area"
      },
      {
        type: x.AREA,
        name: "Satisfactory area"
      },
      {
        type: x.AREA,
        name: "Great area"
      },
      {
        type: x.QUARTILE,
        name: "Quartiles"
      }
    ]
  }
}), jc = h({}, q, {
  bars: {
    dividerSize: 1.5
  },
  timeScale: h(we, {
    addSpaceOnEdges: 0
  })
}), Yc = h({}, _, {
  tooltip: h({}, yt, {
    wordLabel: "Word",
    valueLabel: "Value"
  }),
  wordCloud: {
    fontSizeMapsTo: "value",
    fontSizeRange: (e) => {
      const t = Math.min(e.width, e.height);
      return [t * 20 / 400, t * 75 / 400];
    },
    wordMapsTo: "word"
  }
}), Hr = h({}, _, {
  pie: {
    labels: {
      formatter: null,
      enabled: !0
    },
    alignment: ae.LEFT,
    sortFunction: null,
    valueMapsTo: "value"
  }
}), Gc = h({}, _, {
  legend: {
    enabled: !1
  },
  gauge: {
    type: en.SEMI,
    arcWidth: 16,
    deltaArrow: {
      size: (e) => e / 8,
      enabled: !0
    },
    showPercentageSymbol: !0,
    status: null,
    numberSpacing: 10,
    deltaFontSize: (e) => e / 8,
    valueFontSize: (e) => e / 2.5,
    numberFormatter: (e) => Number(e.toFixed(2)) % 1 !== 0 ? e.toFixed(2).toLocaleString() : e.toFixed().toLocaleString(),
    alignment: ae.LEFT
  }
}), Bc = h({}, Hr, {
  donut: {
    center: {
      numberFontSize: (e) => `${Math.min(e / 100 * 24, 24)}px`,
      titleFontSize: (e) => `${Math.min(e / 100 * 15, 15)}px`,
      titleYPosition: (e) => Math.min(e / 80 * 20, 20),
      numberFormatter: (e) => Math.floor(e).toLocaleString()
    },
    alignment: ae.LEFT
  }
}), qr = h({}, _, {
  legend: {
    enabled: !1,
    clickable: !1
  },
  meter: {
    showLabels: !0,
    proportional: null,
    statusBar: {
      percentageIndicator: {
        enabled: !0
      }
    }
  }
}), Hc = h({}, qr, {
  legend: {
    enabled: !0
  }
}), qc = h({}, _, {
  radar: {
    axes: {
      angle: "key",
      value: "value"
    },
    alignment: ae.LEFT
  },
  tooltip: {
    gridline: {
      enabled: !0
    },
    valueFormatter: (e) => e ?? "N/A"
  }
}), zc = h({}, q, {
  comboChartTypes: []
}), Qc = h(
  {
    tree: {
      type: tn.TREE
    }
  },
  _,
  {}
), Xc = h({}, _, {
  data: h(_.data, {
    groupMapsTo: "name"
  })
}), kc = h({}, _, Rr, {
  data: h(_.data, {
    groupMapsTo: "name"
  })
}), Kc = h({}, _, {
  alluvial: {
    data: h(_.data, {
      groupMapsTo: "source"
    }),
    nodeAlignment: ae.CENTER,
    nodePadding: 24,
    monochrome: !1,
    nodes: []
  }
}), Vc = h({}, _, {
  axes: jr,
  heatmap: {
    divider: {
      state: rn.AUTO
    },
    colorLegend: {
      type: "linear"
    }
  }
}), Zc = h({}, Yr, {
  choropleth: {
    colorLegend: {
      type: "linear"
    }
  }
}), Jc = {
  alluvialChart: Kc,
  areaChart: Br,
  axisChart: Te,
  boxplotChart: Fc,
  bubbleChart: Nc,
  bulletChart: Wc,
  chart: _,
  circlePackChart: kc,
  choroplethChart: Zc,
  comboChart: zc,
  donutChart: Bc,
  gaugeChart: Gc,
  groupedBarChart: Ic,
  heatmapChart: Vc,
  histogramChart: jc,
  lineChart: Gr,
  lollipopChart: Rc,
  meterChart: qr,
  pieChart: Hr,
  proportionalMeterChart: Hc,
  radarChart: qc,
  scatterChart: bt,
  simpleBarChart: Dc,
  stackedAreaChart: Uc,
  stackedBarChart: Lc,
  thematicChart: Yr,
  treeChart: Qc,
  treemapChart: Xc,
  wordCloudChart: Yc
}, cf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alluvial: Oc,
  area: dc,
  axis: hc,
  baseTooltip: yt,
  boxplot: pc,
  canvasZoomSettings: gc,
  carbonPrefix: fc,
  circlePack: Rr,
  color: mc,
  defaultLegendAdditionalItems: Ur,
  grid: Nr,
  heatmap: Sc,
  histogram: vc,
  legend: yc,
  lines: bc,
  meter: wc,
  options: Jc,
  pie: Tc,
  radar: _c,
  ruler: Wr,
  spacers: $c,
  timeScale: we,
  toolbar: Mc,
  tooltips: Pc,
  transitions: Cc,
  zoomBar: xc
}, Symbol.toStringTag, { value: "Module" }));
function ff(e, t, r) {
  let n = null;
  return function(...a) {
    const i = this;
    i.mousePosition = an(a[0], r), clearTimeout(n), n = setTimeout(function() {
      e.apply(i, a);
    }, t);
  };
}
function df(e, t) {
  var a;
  const r = rl(e), n = Object.keys(t.axes || {});
  (a = t == null ? void 0 : t.toolbar) != null && a.controls && delete r.toolbar.controls, n.length === 0 && delete r.axes;
  for (const i in r.axes)
    if (n.includes(i)) {
      const o = t.axes[i];
      (o.primary || o.secondary) && console.warn(
        "`primary` & `secondary` are no longer needed for axis configurations. Read more here https://carbon-design-system.github.io/carbon-charts/?path=/story/docs-tutorials--tabular-data-format"
      );
      const s = o.mapsTo;
      if (s == null) {
        const u = o.scaleType;
        u == null ? o.mapsTo = "value" : u === wt.TIME ? o.mapsTo = "date" : u === wt.LABELS && (o.mapsTo = "key");
      }
    } else
      delete r.axes[i];
  return ef(r, t), h(r, t);
}
function hf(e) {
  if (!e)
    return;
  const t = /translate\([0-9]+\.?[0-9]*,[0-9]+\.?[0-9]*\)/, r = e.getAttribute("transform").match(t);
  if (!r)
    return null;
  if (r[0]) {
    const n = r[0].replace(/translate\(/, "").replace(/\)/, "").split(",");
    return {
      tx: n[0],
      ty: n[1]
    };
  }
  return null;
}
function gf(e) {
  const r = /\(([^)]+)\)/.exec(e);
  if (r && r.length > 1) {
    const n = r[1].split(",");
    if (n.length > 1)
      return {
        x: parseFloat(n[0]),
        y: parseFloat(n[1])
      };
  }
  return { x: 0, y: 0 };
}
function mf(e, t, r = "value", n = !1) {
  const a = e / t.reduce((i, o) => i + o[r], 0) * 100;
  return n ? a : a % 1 !== 0 ? parseFloat(a.toFixed(1)) : a;
}
function pf(e, t, r) {
  if (r > e.length)
    return e;
  if (t === Pe.MID_LINE)
    return e.substr(0, r / 2) + "..." + e.substr(-r / 2);
  if (t === Pe.FRONT_LINE)
    return "..." + e.substr(-r);
  if (t === Pe.END_LINE)
    return e.substr(0, r) + "...";
}
function ef(e, t) {
  const r = G(e, "legend", "additionalItems"), n = G(t, "legend", "additionalItems");
  if (r && n) {
    const a = n.map((s) => s.type), i = r.map((s) => s.type), o = Ur.filter(
      (s) => i.includes(s.type) && !a.includes(s.type)
    );
    e.legend.additionalItems = o, t.legend.additionalItems = cc(
      o,
      n,
      "name"
    );
  }
}
const G = (e, ...t) => {
  let r = e;
  if (r) {
    for (const n of t)
      if (r[n] !== null && r[n] !== void 0)
        r = r[n];
      else
        return null;
    return r;
  }
  return null;
}, tf = (e, t) => t === Jt.HORIZONTAL ? {
  y0: e.x0,
  y1: e.x1,
  x0: e.y0,
  x1: e.y1
} : e, vf = (e, t) => {
  const { x0: r, x1: n, y0: a, y1: i } = tf(e, t);
  return `M${r},${a}L${r},${i}L${n},${i}L${n},${a}L${r},${a}`;
};
function yf(e, t, r) {
  return r === Jt.VERTICAL ? [e, t] : [t, e];
}
var zr = /* @__PURE__ */ ((e) => (e["15seconds"] = "15seconds", e.minute = "minute", e["30minutes"] = "30minutes", e.hourly = "hourly", e.daily = "daily", e.weekly = "weekly", e.monthly = "monthly", e.quarterly = "quarterly", e.yearly = "yearly", e))(zr || {});
const Qe = [
  ["15seconds", 15 * 1e3],
  ["minute", 60 * 1e3],
  ["30minutes", 30 * 60 * 1e3],
  ["hourly", 60 * 60 * 1e3],
  ["daily", 24 * 60 * 60 * 1e3],
  ["monthly", 30 * 24 * 60 * 60 * 1e3],
  ["quarterly", 3 * 30 * 24 * 60 * 60 * 1e3],
  ["yearly", 12 * 30 * 24 * 60 * 60 * 1e3]
];
function rf(e, t, r, n, a) {
  const i = t === 0, o = Number(ke(new Date(e), "c")) === 2, s = Number(ke(new Date(e), "q")) === 1, u = t !== 0 ? r[t - 1] : null;
  switch (n) {
    case "15seconds":
      return i || $e(e) || fe(e, u) || W(e);
    case "minute":
      return i || $e(e) || fe(e, u) || W(e);
    case "30minutes":
      return i || $e(e) || fe(e, u) || W(e);
    case "hourly":
      return i || $e(e) || fe(e, u) || W(e);
    case "daily":
      return a ? i || o || W(e) : i || fe(e, u) || W(e);
    case "weekly":
      return i || o || W(e);
    case "monthly":
      return i || W(e);
    case "quarterly":
      return i || s;
    case "yearly":
      return !1;
    default:
      throw new Error(`${n} is not a valid time interval.`);
  }
}
function bf(e, t, r, n, a) {
  const i = a.showDayName, o = n === "daily" && i ? "weekly" : n, s = new Date(e), u = G(a, "timeIntervalFormats")[o], l = G(u, "primary"), f = G(u, "secondary");
  let c = rf(e, t, r, n, i) ? l : f;
  n === "15seconds" && s.getMilliseconds() !== 0 && (c = c.replace("pp", "h:mm:ss.SSS a"));
  const d = a.localeObject;
  return ke(s, c, { locale: d });
}
function Ie(e) {
  const t = new Date(e);
  return {
    M: t.getMonth() + 1,
    // month: 1-12
    d: t.getDate(),
    // day of the month: 1-31
    H: t.getHours(),
    // 24-hour clock: 0-23
    m: t.getMinutes(),
    // minute: 0-59
    s: t.getSeconds()
    // seconds: 0-59
  };
}
function nf(e) {
  if (e)
    return e.slice(1).map((t, r) => t - e[r]);
}
function af(e) {
  const t = Qe.reduce((r, [, n], a) => {
    const i = Qe[r][1], o = Math.abs(i - e), s = Math.abs(n - e);
    return o < s ? r : a;
  }, 0);
  return Qe[t][0];
}
function wf(e, t) {
  if (zr[t])
    return t;
  if (e.length === 1)
    return "15seconds";
  const r = nf(e), n = on(r);
  return af(n);
}
function $e(e) {
  const { s: t, m: r, H: n } = Ie(e);
  return n === 0 && r === 0 && t === 0;
}
function fe(e, t) {
  const r = Ie(e).M, n = Ie(t).M;
  return r !== n;
}
function W(e) {
  const { M: t, d: r, s: n, m: a, H: i } = Ie(e);
  return t === 1 && r === 1 && i === 0 && a === 0 && n === 0;
}
function Tf(e) {
  return e === void 0 ? "" : e.toISOString();
}
function of(e) {
  const t = sn(e, (n) => n.value), r = un().domain(t).nice().domain();
  if (r[0] > 0)
    r[0] = 0;
  else if (r[0] === 0 && r[1] === 0)
    return [0, 1];
  return r[0] < 0 && r[1] > 0 && (Math.abs(r[0]) > r[1] ? r[1] = Math.abs(r[0]) : r[0] = -r[1]), r;
}
function _f(e, t) {
  const r = G(t, "gradient", "colors"), n = !nc(r);
  let a = G(t, "pairing", "option");
  const i = of(e), o = i[0] < 0 && i[1] > 0 ? "diverge" : "mono";
  (a < 1 && a > 4 && o === "mono" || a < 1 && a > 2 && o === "diverge") && (a = 1);
  const s = n ? r : [];
  if (!n) {
    const u = o === "diverge" ? 17 : 11;
    for (let l = 1; l < u + 1; l++)
      s.push(`fill-${o}-${a}-${l}`);
  }
  return ln().domain(i).range(s);
}
export {
  pf as $,
  bc as A,
  wc as B,
  Tc as C,
  _c as D,
  Wr as E,
  $c as F,
  we as G,
  Pc as H,
  Cc as I,
  Mc as J,
  xc as K,
  wf as L,
  Tf as M,
  bf as N,
  _f as O,
  of as P,
  Ie as Q,
  rf as R,
  S,
  Qe as T,
  Ua as U,
  ql as V,
  yr as W,
  vt as X,
  ol as Y,
  Ai as Z,
  cs as _,
  nt as a,
  ke as a0,
  nc as a1,
  yf as a2,
  gf as a3,
  hf as a4,
  ff as a5,
  vf as a6,
  tf as a7,
  mf as a8,
  lf as a9,
  Sc as aa,
  st as ab,
  ef as ac,
  O as ad,
  E as ae,
  B as af,
  hn as ag,
  mn as ah,
  Xl as b,
  I as c,
  fc as d,
  rl as e,
  h as f,
  G as g,
  cf as h,
  ye as i,
  Oc as j,
  Ue as k,
  dc as l,
  df as m,
  hc as n,
  Jc as o,
  yt as p,
  pc as q,
  D as r,
  gc as s,
  us as t,
  Rr as u,
  mc as v,
  Ur as w,
  Nr as x,
  vc as y,
  yc as z
};
//# sourceMappingURL=color-scale-utils-2eb80bd2.mjs.map
